import React, { useState } from 'react'
import styled from 'styled-components'
import { ChainId, INTEGRAL_TOKEN } from '../../../constants'
import { getStakingParams, getStakingRewards } from '../../../pages/token/staking/utils'
import { StakingDepositInfo } from '../../../providers/transactions/model'
import { Parameter, Parameters } from './Parameters'
import { SingleItem } from './SingleItem'

interface Props {
  now: Date
  submittedAt: number
  txInfo: StakingDepositInfo
}

export function SingleStakingDepositItem({ now, submittedAt, txInfo }: Props) {
  const [active, setActive] = useState(false)
  const { stakingOption, value } = txInfo
  const { duration, apr } = getStakingParams(stakingOption)
  const integralToken = INTEGRAL_TOKEN[ChainId.Mainnet]
  const { symbol } = integralToken
  const rewards = getStakingRewards(stakingOption, integralToken, value)

  return (
    <Container onMouseEnter={() => setActive(true)} onMouseLeave={() => setActive(false)}>
      <SingleItem description={`Stake ${symbol}`} now={now} submittedAt={submittedAt} symbol0={symbol} />
      <Parameters>
        <Parameter text={'Amount'} value={`${value} ${symbol}`} />
        {active && (
          <>
            <Parameter text={'Duration'} value={duration} />
            <Parameter text={'APR'} value={apr} />
            <Parameter text={'Total Rewards'} value={`${rewards} ${symbol}`} />
          </>
        )}
      </Parameters>
    </Container>
  )
}

const Container = styled.div``
